export const userLoginAPI =
  "https://catalogmaker.in/catalogMakerApi/public/api/";
